import env from '../config';

export const otherwiseConfigBlock = ['$urlRouterProvider', $urlRouterProvider => { 
    $urlRouterProvider.otherwise('/app');
}];

export const html5ConfigBlock = ['$locationProvider', $locationProvider => { 
    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
    });
}];

export const themeConfigBlock = ['ThemeServiceProvider', '$animateProvider', ( ThemeServiceProvider: aboTheme.IThemeProvider, $animateProvider: any ) => { 
    ThemeServiceProvider.setLogo(<string>require('../../images/logo-white.png')); 
    ThemeServiceProvider.setLogoDark(<string>require('../../images/logo-dark.png')); 
    $animateProvider.classNameFilter(/ng-animate-enabled/);
}];

export const masterDataConfigBlock = ['MasterdataServiceProvider', ( MasterdataServiceProvider: aboMasterdata.IServiceProvider ) => {
    MasterdataServiceProvider.setType('Skills', 'SKILLS');
    MasterdataServiceProvider.setType('Functions', 'Functions');
    MasterdataServiceProvider.setType('Hour codes', 'HourCodes');
    MasterdataServiceProvider.setType('Availability status', 'AvalabilityStatus');
    MasterdataServiceProvider.setType('Transportation type', 'TransportationType');
    MasterdataServiceProvider.setType('Note Tags', 'NoteTags');
    MasterdataServiceProvider.setType('Contact Tags', 'ContactTags');
    MasterdataServiceProvider.setType('Task Status', 'TaskStatus');
    MasterdataServiceProvider.setType('Preferred target audience', 'PreferredTargetAudience');
    MasterdataServiceProvider.setType('Application status', 'ApplicationStatus');
    MasterdataServiceProvider.setApiItemName('masterdata');
}];

export const config = ['RestangularProvider', 'localStorageServiceProvider', (
    RestangularProvider: Restangular.IProvider,
    localStorageServiceProvider: ng.local.storage.ILocalStorageServiceProvider
) => {

    RestangularProvider.setBaseUrl(env.API_URL);
    localStorageServiceProvider.setStorageType('sessionStorage');

}];


// WEBPACK FOOTER //
// ./src/app/main/app.config.ts